module.exports = __webpack_public_path__ + "static/semantic-icon-colored-a872b205a7c38c30db5d4d20155fb956.png";